import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { useStore } from '../context/StoreContext';
import { useProducts } from '../hooks/useProducts';

export default function Wishlist() {
  const navigate = useNavigate();
  const { wishlist } = useStore();
  const { products, loading } = useProducts();

  const wishlistProducts = products.filter(p => wishlist.includes(p.id));

  if (loading) return (
    <div className="app-shell">
      <Navbar showBack title="Wishlist" />
      <div className="page-body">
        <div className="loading-grid">
          {[...Array(4)].map((_, i) => <div key={i} className="prod-skeleton"></div>)}
        </div>
      </div>
      <BottomNav />
    </div>
  );

  return (
    <div className="app-shell">
      <Navbar showBack title="Wishlist" />
      <div className="page-body">
        <div className="section-header" style={{ marginBottom: 20 }}>
          <span className="section-title">My Wishlist</span>
          <span style={{ fontSize: 11, color: 'var(--muted)' }}>{wishlistProducts.length} items</span>
        </div>

        {wishlistProducts.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <i className="ti ti-heart" style={{ fontSize: 48, color: 'var(--muted)', marginBottom: 16, display: 'block' }}></i>
            <div style={{ fontSize: 15, fontWeight: 500, marginBottom: 8 }}>Your wishlist is empty</div>
            <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 24 }}>Save items you love by tapping the heart icon</div>
            <button className="btn-blue" style={{ width: 'auto', padding: '12px 28px' }} onClick={() => navigate('/shop')}>
              Browse products
            </button>
          </div>
        ) : (
          <div className="prod-grid">
            {wishlistProducts.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
      <Footer />
      <BottomNav />
    </div>
  );
}